import { Dashboard } from '@mui/icons-material';

export const FEATURE_TOGGLE = {
  GroupChat: 'v2.2402.06_group-chat',
  BillingAccountOrderCreation: 'v2.2402.20_billing-account-order-creation',
  WorkerRating: 'worker-rating',
  HideBrokenReports: 'hide-broken-reports',
  ClientAdminToDeleteAccount:
    'v2.2405.14_allow-customer-admins-to-delete-account',
  DashboardApprovalStatusFeature: 'v2.2410.22_needs-approval',
  SelectNearestAddressRateFeature: 'v2.2404.30_select_nearest_address_rate',
  SameWorkerAllShifts: 'v2.2401.09_same-worker-all-shifts',
  RemoveAddressCreationOnOrder:
    'v2.2405.28_remove-address-creation-during-order-creation',
  WorkerProfileRevamp: 'v2.2406.11_worker-profile-revamp',
  RemoveHolidayRates: 'v2.2407.02_remove-holiday-rates',
  LockBillRates: 'v2.2408.06_lock_bill_rates',
  HideDisabledBillingAccount: 'v2.2408.06_disable_billing_accounts',
  ForceUpdateClientApp: 'v2.2408.20_force-update-client-app',
  HelpdeskRole: 'v2.2409.03_helpdesk-role',
  TipsInCents: 'v2.2409.10_add-cents-in-tips',
  TipsInCentsWeb: 'v2.2409.10_add-cents-in-tips-web',
  JobTimezoneFeature: 'v2.2410.08_show-job-as-per-timezone',
  EnablePayrollProcessBackgroundJob:
    'v2.2410.08_enable-payroll-process-background-job',
  DashboardFiltersAndPersistView:
    'v2.2411.19_dashboard-filters-and-persistent-view',
  DashboardMobileFriendlyNavigation:
    'v2.2411.19_dashboard-mobile-friendly-navigation',
  EmploymentEligibilityCompliancely:
    'v2.2412.17_employment-eligibility-compliancely',
  LimitJobDetailEdits: 'v2.2412.17_limit-job-detail-edits',
  WorkerBadge: 'v2.2412.17_worker-badge',
  ChatIntercomIcon: 'v2.2412.17_chat-intercom-icon',
  ChatIntercomIconIOS: 'v2.2412.17_chat-intercom-icon-ios',
  WorkerBadgeClient: 'v2.2412.31_worker-badge-client',
  OpenAppLink: 'v2.2412.31_client-app-download',
  ReleaseNotesAdmin: 'v2.2501.14_release-notes',
  TimesheetScrutiny: 'v2.2501.28_timesheet-scrutiny',
  ShowDownloadInvoice: 'v2.2502.25_show-download-invoice',
  RefiningInvoiceNumber: 'v2.2502.25_refining-invoice-number',
  NavigationImprovements: 'v2.2502.11_navigation-improvements',
  AdditionalBillingEmail: 'v2.2411.19_additional-contact-billing-account',
  JobFulfillment: 'v2.2507.22_job-fulfillment',
};
